// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"6df1f59487052f1544a4","339":"9cdaa3ec5f23e9e60beb"}[chunkId] + ".js";
};